let support;

export const isWebpSupported = () => {
    if (support !== undefined) return support;

    if (typeof document === "undefined") {
        support = false;
        return support;
    }

    try {
        const canvas = document.createElement("canvas");
        support = canvas.toDataURL("image/webp").indexOf("data:image/webp") === 0;
    }
    catch (err) {
        support = false;
    }

    return support;
};

export const getWebpAwareExtension = () => isWebpSupported() ? ".webp" : ".png";
export const getWebpAwareExtensionWithoutDot = () => isWebpSupported() ? "webp" : "png";
